import { Controller } from '@hotwired/stimulus';

export class PushNotificationBannerController extends Controller<HTMLElement> {
    static values = { forceShow: Boolean };

    declare readonly forceShowValue: boolean;
    private static readonly dismissedStorageKey = 'ovasai.push-notification-banner.dismissed.v1';

    connect(): void {
        if (!this.shouldShow()) {
            this.element.classList.add('hidden');
            return;
        }

        this.element.classList.remove('hidden');
    }

    dismiss(): void {
        try {
            window.localStorage.setItem(PushNotificationBannerController.dismissedStorageKey, 'true');
        } catch (error) {
            console.warn('push notification banner dismissal could not be saved', error);
        }
        this.element.classList.add('hidden');
    }

    private shouldShow(): boolean {
        if (!this.isSupported()) {
            return false;
        }
        if (Notification.permission !== 'default') {
            return false;
        }
        try {
            return this.forceShowValue || window.localStorage.getItem(PushNotificationBannerController.dismissedStorageKey) !== 'true';
        } catch {
            return true;
        }
    }

    private isSupported(): boolean {
        return (
            'serviceWorker' in navigator
            && 'PushManager' in window
            && 'Notification' in window
            && window.isSecureContext
        );
    }
}
